var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 21,
    className: "st0",
    width: 14,
    height: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,27v-6H8c-0.6,0-1,0.4-1,1v5H23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23,29H7v29c0,0.6,0.4,1,1,1h15V29z M14,33h4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1S13.4,33,14,33z  M18,53h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S18.6,53,18,53z M18,47h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1 S18.6,47,18,47z M18,41h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S18.6,41,18,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,27h16v-5c0-0.6-0.4-1-1-1H41V27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,29v30h15c0.6,0,1-0.4,1-1V29H41z M50,53h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S50.6,53,50,53z  M50,47h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S50.6,47,50,47z M50,41h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1 S50.6,41,50,41z M50,35h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S50.6,35,50,35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,59h14V29H25V59z M30,33h4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1S29.4,33,30,33z M30,39h4 c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1S29.4,39,30,39z M30,45h4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1 S29.4,45,30,45z M30,51h4c0.6,0,1,0.4,1,1s-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1S29.4,51,30,51z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTable);
export default __webpack_public_path__ + "static/media/data_table.48d9d766761e078fa0c3d2c071bb31f9.svg";
export { ForwardRef as ReactComponent };